$(document).ready(function() {
    App.init();
    App.mobileMenu('.js-menu');
    App.formPopup('.js-popup');
});
